import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import { createStyles, withStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import * as React from "react";
import materialOverrides from "./QuiqButtonMaterialOverrides.js";

export interface ButtonProps {
  className?: string;
  isDisabled?: boolean;
  isLoading?: boolean;
  variant?:
    | "text"
    | "flat"
    | "outlined"
    | "contained"
    | "raised"
    | "fab"
    | "extendedFab";
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  color?: "blue" | "green" | "red" | "white";
  type?: "button" | "reset" | "submit" | undefined;
}

const styles = createStyles(materialOverrides);

const QuiqButton: React.SFC<ButtonProps> = ({
  className,
  children,
  color,
  isDisabled,
  isLoading,
  ...otherProps
}) => (
  <div
    className={classnames("QuiqButton", {
      [`${className}`]: className
    })}
  >
    <div className="QuiqButton__container">
      <Button
        className={classnames("QuiqButton__button", {
          [`QuiqButton__button--${color}`]: color
        })}
        disabled={isDisabled || isLoading}
        {...otherProps}
      >
        {children}
      </Button>
    </div>

    {isLoading && (
      <div className="QuiqButton__container">
        <CircularProgress size={24} className="QuiqButton__spinner" />
      </div>
    )}
  </div>
);

QuiqButton.defaultProps = {
  className: "",
  isDisabled: false,
  isLoading: false,
  variant: "contained",
  type: "button"
};

export default withStyles(styles)(QuiqButton);



// WEBPACK FOOTER //
// ./src/shared/QuiqButton.tsx